import React from 'react';
import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Dropdown from '../../../atoms/Dropdown';
import InformTooltip from './InformTooltip';
// import { navigateToNewTab } from '../../../../utils/toNewTab';

const TooltipValue = ({ value }) => <Typography variant="bodyM">{value}</Typography>;
TooltipValue.propTypes = {
  value: PropTypes.string.isRequired,
};

const dayOptions = Array.from({ length: 30 }, (_, i) => i + 1).map((day) => ({
  value: day,
  label: day,
}));

const ValueCell = ({ isReferenceType, value, row: { original }, column }) => {
  // Code was commented as it was NOT clear from AC's where should links navigate
  // const goToPage = () => {
  // if (!row.original.id) return;
  // navigateToNewTab(`/db/processing/case/${row.original.caseId}`)
  // };

  if (isReferenceType) {
    return (
      <Stack
        // sx={{ cursor: 'pointer' }}
        alignItems="center"
      >
        <Typography
          variant="bodyM"
          // sx={{ textDecoration: 'underline' }}
          // onClick={goToPage}
        >
          {value}
        </Typography>
      </Stack>
    );
  }

  const getColumnId = () => {
    return column?.id?.split('.')[0];
  };

  const columnId = getColumnId();
  const changeDate = original?.[columnId]?.changeDate;
  const notificationType = original?.[columnId]?.notificationType;

  return (
    <Stack width={100} alignItems="center" position="relative">
      <InformTooltip type={notificationType} />
      <Dropdown
        isColumn
        isSearchable
        width="100%"
        defaultValue={dayOptions.find((option) => option.value === value)}
        value={{ value, label: value }}
        onChange={(option) => {
          if (changeDate) changeDate(option);
        }}
        options={dayOptions}
      />
    </Stack>
  );
};

ValueCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      changeDate: PropTypes.func,
    }),
  }).isRequired,
  isReferenceType: PropTypes.bool,
  column: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

ValueCell.defaultProps = {
  value: '',
  isReferenceType: false,
};

export default ValueCell;
